import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {
    AlertaMatriculaRechazadaViewModel,
    AlertaProductoRechazadoExViewModel,
    AlertaProductoRechazadoViewModel,
    CambioPcfViewModel,
} from './alertaRechazo.types';
import { SolicitudExRelacionAtestacionesViewModel } from '../../../_exportacion/solicitudes/relacionatestaciones/relacionatestaciones.types';
import { TClaveSolicitudAtestFitoViewModel } from '../../../_exportacion/atestaciones/datosbasicos/datosbasicosAtestFito.types';
import { SolicitudExViewModel } from '../../../_exportacion/solicitudes/datosbasicos/datosbasicosEx.types';
import { SolicitudViewModel } from '../../../_importacion/solicitudes/datosbasicos/datosbasicos.types';

@Injectable()
export class AlertaRechazoService {
    paramsKey = 'params';
    private lastAlertsProdImp?: AlertaProductoRechazadoViewModel;
    private lastAlertsMatImpRechazadas: AlertaMatriculaRechazadaViewModel[];
    private lastAlertsMatImp: AlertaMatriculaRechazadaViewModel[];
    private lastAlertsProdExp?: AlertaProductoRechazadoExViewModel;
    private lastAtestaciones: TClaveSolicitudAtestFitoViewModel[];
    private lastSolAnulSust?: SolicitudExViewModel;
    private mensajeSolAnulSust = '';
    private lastHijasRechazoParcial: SolicitudViewModel[];
    private lastPadreRechazoParcial: SolicitudViewModel;
    private lastTrasladoPadre: SolicitudViewModel;
    private lastNormalHija: SolicitudViewModel;

    private lastIdSolicitud?: number;

    constructor(
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {}

    getProductosSolicitudRechazados(idSolicitud: number): Observable<AlertaProductoRechazadoViewModel> {
        return this.http.get<AlertaProductoRechazadoViewModel>(this.baseUrl + 'api/importacion/solicitud/productosSolicitudRechazados/' + idSolicitud).pipe();
    }

    getMatriculasRechazadas(idSolicitud: number): Observable<AlertaMatriculaRechazadaViewModel[]> {
        return this.http
            .get<AlertaMatriculaRechazadaViewModel[]>(this.baseUrl + 'api/importacion/solicitud/matriculasRechazadasByIdSolicitud/' + idSolicitud)
            .pipe();
    }

    getMatriculas(idSolicitud: number): Observable<AlertaMatriculaRechazadaViewModel[]> {
        return this.http.get<AlertaMatriculaRechazadaViewModel[]>(this.baseUrl + 'api/importacion/solicitud/matriculasByIdSolicitud/' + idSolicitud).pipe();
    }

    getProductosSolicitudExRechazados(idSolicitudEx: number): Observable<AlertaProductoRechazadoExViewModel> {
        return this.http
            .get<AlertaProductoRechazadoExViewModel>(this.baseUrl + 'api/exportacion/solicitudEx/productosSolicitudRechazadosEx/' + idSolicitudEx)
            .pipe();
    }

    getAlertasProdImp(id: number): AlertaProductoRechazadoViewModel | undefined {
        if (id == this.lastIdSolicitud) {
            return this.lastAlertsProdImp;
        }
        return undefined;
    }

    setAlertasProdImp(results: AlertaProductoRechazadoViewModel, id: number): void {
        this.lastAlertsProdImp = results;
        this.lastIdSolicitud = id;
    }

    getAlertasMatImpRechazadas(id: number): AlertaMatriculaRechazadaViewModel[] | [] {
        if (id == this.lastIdSolicitud) {
            return this.lastAlertsMatImpRechazadas;
        }
        return [];
    }

    getAlertasMatImp(id: number): AlertaMatriculaRechazadaViewModel[] | [] {
        if (id == this.lastIdSolicitud) {
            return this.lastAlertsMatImp;
        }
        return [];
    }

    setAlertasMatImpRechazadas(results: AlertaMatriculaRechazadaViewModel[], id: number): void {
        this.lastAlertsMatImpRechazadas = results;
        this.lastIdSolicitud = id;
    }

    setAlertasMatImp(results: AlertaMatriculaRechazadaViewModel[], id: number): void {
        this.lastAlertsMatImp = results;
        this.lastIdSolicitud = id;
    }

    getAlertasProdExp(id: number): AlertaProductoRechazadoExViewModel | undefined {
        if (id == this.lastIdSolicitud) {
            return this.lastAlertsProdExp;
        }
        return undefined;
    }

    setAlertasProdExp(results: AlertaProductoRechazadoExViewModel, id: number): void {
        this.lastAlertsProdExp = results;
        this.lastIdSolicitud = id;
    }

    getRelacionatestaciones(id: number): Observable<SolicitudExRelacionAtestacionesViewModel> {
        return this.http.get<SolicitudExRelacionAtestacionesViewModel>(this.baseUrl + 'api/exportacion/solicitudEx/getRelacionAtestaciones/' + id).pipe();
    }

    getAtestaciones(id: number): TClaveSolicitudAtestFitoViewModel[] | [] {
        if (id == this.lastIdSolicitud) {
            return this.lastAtestaciones;
        }
        return [];
    }

    setAtestaciones(results: TClaveSolicitudAtestFitoViewModel[], id: number): void {
        this.lastAtestaciones = results;
        this.lastIdSolicitud = id;
    }

    getSolAnulSust(id: number): { model: SolicitudExViewModel | undefined; msj: string } | undefined {
        if (id == this.lastIdSolicitud) {
            return { model: this.lastSolAnulSust, msj: this.mensajeSolAnulSust };
        }
        return undefined;
    }

    setSolAnulSust(results: SolicitudExViewModel, id: number, msj: string): void {
        this.lastSolAnulSust = results;
        this.lastIdSolicitud = id;
        this.mensajeSolAnulSust = msj;
    }

    getSolicitudesJerarquiaByIdPadre(id: number): Observable<SolicitudViewModel[]> {
        return this.http.get<SolicitudViewModel[]>(this.baseUrl + 'api/importacion/solicitud/getSolicitudesJerarquiaByIdPadre/' + id).pipe();
    }

    getHijasRechazoParcial(id: number): SolicitudViewModel[] | [] {
        if (id == this.lastIdSolicitud) {
            return this.lastHijasRechazoParcial;
        }
        return [];
    }

    setHijasRechazoParcial(results: SolicitudViewModel[], id: number): void {
        this.lastHijasRechazoParcial = results;
        this.lastIdSolicitud = id;
    }

    resetHijasRechazoParcial(id: number) {
        if (id != this.lastIdSolicitud) {
            this.lastHijasRechazoParcial = [];
        }
    }

    getSolicitudPadreJerarquiaById(id: number): Observable<SolicitudViewModel> {
        return this.http.get<SolicitudViewModel>(this.baseUrl + 'api/importacion/solicitud/getSolicitudPadreJerarquiaById/' + id).pipe();
    }

    getSolicitudTrasladoPadreJerarquiaById(id: number): Observable<SolicitudViewModel> {
        return this.http.get<SolicitudViewModel>(this.baseUrl + 'api/importacion/solicitud/getSolicitudTrasladoPadreJerarquiaById/' + id).pipe();
    }

    getSolicitudNormalHijaJerarquiaById(id: number): Observable<SolicitudViewModel> {
        return this.http.get<SolicitudViewModel>(this.baseUrl + 'api/importacion/solicitud/getSolicitudNormalHijaJerarquiaByIdPadreAsync/' + id).pipe();
    }

    getPadreRechazoParcial(id: number): SolicitudViewModel | undefined {
        if (id == this.lastIdSolicitud) {
            return this.lastPadreRechazoParcial;
        }
        return undefined;
    }

    setPadreRechazoParcial(results: SolicitudViewModel, id: number): void {
        this.lastPadreRechazoParcial = results;
        this.lastIdSolicitud = id;
    }

    getTrasladoPadre(id: number): SolicitudViewModel | undefined {
        if (id == this.lastIdSolicitud) {
            return this.lastTrasladoPadre;
        }
        return undefined;
    }

    setTrasladoPadre(results: SolicitudViewModel, id: number): void {
        this.lastTrasladoPadre = results;
        this.lastIdSolicitud = id;
    }

    getNormalHija(id: number): SolicitudViewModel | undefined {
        if (id == this.lastIdSolicitud) {
            return this.lastNormalHija;
        }
        return undefined;
    }

    setNormalHija(results: SolicitudViewModel, id: number): void {
        this.lastNormalHija = results;
        this.lastIdSolicitud = id;
    }

    getSolicitudById(id: number): Observable<SolicitudViewModel> {
        return this.http.get<SolicitudViewModel>(this.baseUrl + 'api/importacion/solicitud/GetSolicitudLigeraAlertas/' + id).pipe();
    }

    getSolicitudExById(id: number): Observable<SolicitudExViewModel> {
        return this.http.get<SolicitudExViewModel>(this.baseUrl + 'api/exportacion/solicitudEx/getSolicitudById/' + id).pipe();
    }

    validarCambioPcf(id: number): Observable<CambioPcfViewModel[]> {
        return this.http.get<CambioPcfViewModel[]>(this.baseUrl + 'api/exportacion/solicitudEx/validarCambioPcf/' + id).pipe();
    }

    getSolicitudExConJerarquiaById(id: number): Observable<SolicitudExViewModel> {
        return this.http.get<SolicitudExViewModel>(this.baseUrl + 'api/exportacion/solicitudEx/GetSolicitudExConJerarquiaById/' + id).pipe();
    }
}
